<template>
    <ToggleSimple @update:open="toggleOpen = $event">
        <template #toggle>
            <div class="left">
                <div v-if="$te(`fields.${name}.label`)" class="toggle-text">
                    {{ $t(`fields.${name}.label`) }}
                    <span v-if="count.selected && count.selected > 0">{{ count.selected }}</span>
                </div>
                <div v-if="$te(`fields.${name}.description`)" class="toggle-description">
                    {{ $t(`fields.${name}.description`) }}
                </div>
            </div>
            <div class="right">
                <div v-if="isActive" class="reset" @click="resetSection">
                    <div class="icon-reset-pos"></div>
                </div>
                <div class="toggle-icon"></div>
            </div>
        </template>

        <template #content>
            <div :class="cssClassOptions">
                <CustomIncludesExcludes
                    v-model="options"
                    v-if="count.selected > 0"
                    :inputKey="name"
                    :showRequired="true"
                    :smHorizontal="!narrow"
                    @update:modelValue="onListsChanged"
                />

                <CustomSuggest 
                    :inputKey="name"
                    :fetchSuggestionsFn="fetchAppSuggestions"
                    :excludedValues="excludedValues"
                    @select-suggestion="addSuggestion"
                    :showLabel="false"
                    :selectMultiple="true"
                    ref="suggest"
                />
            </div>
        </template>
    </ToggleSimple>
</template>

<script>
    import { fetchSuggestions } from '@/services/freeApi';
    import { nextTick } from 'vue';
    import ToggleSimple from '@/components/misc/ToggleSimple';
    import CustomIncludesExcludes from '@/components/inputs/CustomIncludesExcludes';
    import CustomSuggest from '@/components/inputs/CustomSuggest';

    export default {
        name: "OptionsApps",
        components: {
            ToggleSimple,
            CustomIncludesExcludes,
            CustomSuggest
        },
        props: {
            modelValue: {
                type: Object,
                default: () => ({ includes: [], excludes: [], required: [] })
            },
            defaultVal: {
                type: Object,
                default: () => ({ includes: [], excludes: [], required: [] })
            },
            showDescriptions: {
                type: Boolean,
                default: true
            },
            cssClassOptions: {
                type: String,
                default: 'options-type-4'
            },
            narrow: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                name: 'apps_alt',
                toggleOpen: false,
                options: {
                    includes: this.modelValue?.includes || [],
                    excludes: this.modelValue?.excludes || [],
                    required: this.modelValue?.required || []
                }
            };
        },
        computed: {
            isActive() {
                return JSON.stringify(this.modelValue) !== JSON.stringify(this.defaultVal);
            },
            excludedValues() {
                return [
                    ...this.options.includes.map(app => app.value),
                    ...this.options.excludes.map(app => app.value),
                    ...this.options.required.map(app => app.value)
                ];
            },
            count() {
                return {
                    total: this.options.includes.length + this.options.excludes.length  + this.options.required.length,
                    selected: this.options.includes.length + this.options.excludes.length  + this.options.required.length,
                    includes: this.options.includes.length + this.options.required.length,
                    excludes: this.options.excludes.length,
                };
            }
        },
        methods: {
            resetSection(event = null) {
                if (event) {
                    event.stopPropagation();
                }
                this.options = {
                    includes: [],
                    excludes: [],
                    required: []
                };

                if(this.$refs.suggest && typeof this.$refs.suggest.clearSearch === 'function') {
                    this.$refs.suggest.clearSearch();
                }

                this.emitUpdate();
            },
            async fetchAppSuggestions(query) {
                try {
                    const response = await fetchSuggestions({
                        type: 'apps',
                        q: query
                    });
                    return response.data.suggest.map(suggestion => ({
                        value: suggestion.term,
                        text: suggestion.name,
                        icon: suggestion.img
                    }));
                } catch {
                    return [];
                }
            },
            addSuggestion(suggestion) {
                this.options.includes.push(suggestion);
                this.emitUpdate();
            },
            onListsChanged(newValue) {
                this.options = newValue;
                this.emitUpdate();
            },
            emitUpdate() {
                nextTick(() => {
                    this.$emit('update:modelValue', this.options);
                });
            }
        },
        watch: {
            modelValue: {
                handler(newVal) {
                    this.options = {
                        includes: newVal?.includes || [],
                        excludes: newVal?.excludes || [],
                        required: newVal?.required || []
                    };
                },
                immediate: true
            }
        }
    }
</script>